import { Flex } from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'
import { Tab, TabProps } from './Tab'

type TabBarProps = {
  tabs: TabProps[]
  activeTabIndex: number
  barBackgroundColor?: string
  activeTabBackgroundColor?: string
  activeTabTextColor?: string
  barBoxShadow?: string
  radius?: string
  height?: string
  tabTextSize?: string
  tabInsetVertical?: string
  shouldHideText?: boolean
}

export const TabBar: FC<TabBarProps> = ({
  tabs,
  activeTabIndex,
  radius = '100px',
  height = '62px',
  activeTabBackgroundColor,
  activeTabTextColor,
  barBackgroundColor = '#f5f6f7',
  barBoxShadow,
  tabTextSize,
  tabInsetVertical,
  children,
  shouldHideText = false,
}) => {
  return (
    <Flex style={{ overflow: 'visible' }}>
      <Flex
        rowGap="x2"
        justifyContent="flex-start"
        backgroundColor={barBackgroundColor}
        inset="x_75"
        style={{
          borderRadius: radius,
          boxShadow: barBoxShadow,
          overflow: 'visible',
        }}
        height={height}
      >
        {tabs.map((tab, index) => {
          return (
            <Flex key={tab.title} width="100%">
              <Tab
                icon={tab.icon}
                radius={radius}
                isActive={index === activeTabIndex}
                activeTabBackgroundColor={activeTabBackgroundColor}
                activeTabTextColor={activeTabTextColor}
                tabBarBackground={barBackgroundColor}
                textSize={tabTextSize}
                insetVertical={tabInsetVertical}
                title={tab.title}
                shouldHideText={shouldHideText}
                onClick={tab.onClick}
              />
            </Flex>
          )
        })}
      </Flex>
      {children}
    </Flex>
  )
}
